import React from "react";
import { Typography, Box, useTheme } from "@material-ui/core";
import CloseX from "../../../icons/CloseX";
import classes from "./Modal.module.scss";

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose }) => {
  const theme = useTheme();
  return (
    <Box
      className={classes.modalHeaderContainer}
      sx={{
        padding: theme.spacing(6),
      }}
    >
      <Typography variant="h4">{title}</Typography>
      <span className={classes.dismissButton} role="button" onClick={onClose}>
        <CloseX />
      </span>
    </Box>
  );
};

export default ModalHeader;
